/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { Button } from 'components/Button';
import { Title } from 'components/Text';
import { StyledDialog, Content, BoxButtons } from './styles';

// Modal do Código de confirmaçÃo
const GetOutModal = ({
  open,
  onClose,
}) => (
  <StyledDialog
    open={open}
    onClose={() => onClose(false)}
  >
    <Content>
      <IconButton
        color="secondary"
        onClick={() => onClose(false)}
      >
        <CloseIcon />
      </IconButton>
      <Title>Como podemos te ajudar?</Title>
      <BoxButtons>
        <Button
          onClick={() => {
            window.Intercom('trackEvent', 'LOIT FGTS central de ajuda');
            window.open('https://ajuda.tikal.tech/pt-BR/collections/2748191-loit-fgts');
            onClose(false);
          }}
        >
          Abrir central de ajuda
        </Button>
        <Button
          variant="outlined"
          onClick={() => {
            window.Intercom('trackEvent', `LOIT FGTS chat de ajuda - ${window.location.pathname.replace('/', '')}`);
            window.Intercom('show');
            onClose(false);
          }}
        >
          Iniciar conversa com o suporte
        </Button>
        <a
          target="_blank"
          href={process.env.REACT_APP_TOUR}
          rel="noopener noreferrer"
        >
          Visualizar tutorial
        </a>
      </BoxButtons>
    </Content>
  </StyledDialog>
);

GetOutModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default GetOutModal;
